<span [textContent]="'+' + displayNumber()"
      [class.td-wb-symbol-logo-overflow--extra-small]="isExtraSmall()"
      [class.td-wb-symbol-logo-overflow--small]="isSmall()"
      [class.td-wb-symbol-logo-overflow--extra-large]="isExtraLarge()"></span>
